import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import style from './FormComponent.css';

const FormComponentWithLabel = ({
  name,
  type,
  placeholder,
  value,
  onChange,
  errorMessage,
  ...props
}) =>
  <div className={style.formComponent}>
    <label style={{ fontWeight: 700 }} htmlFor={name}>
      <span>
        {name[0].toUpperCase() + name.substring(1)}
      </span>
    </label>
    <div>
      {type === 'textArea'
        ? <textarea
            className={cx('form-control', style.textArea)}
            name={name}
            value={value == null ? undefined : value}
            onChange={onChange}
            placeholder={placeholder}
            {...props}
          />
        : <input
            className="form-control"
            name={name}
            type={type}
            value={value == null ? undefined : value}
            onChange={onChange}
            placeholder={placeholder}
            {...props}
          />}
      {errorMessage &&
        <div
          className={cx('alert', 'alert-danger', style.errorMessage)}
          role="alert"
        >
          <span className={cx('fa', 'fa-info-circle', style.alertIcon)}></span>
          <span>{errorMessage}</span>
        </div>}
    </div>
  </div>;

const FormComponentWithoutLabel = ({
  name,
  type,
  placeholder,
  value,
  onChange,
  errorMessage,
  ...props
}) =>
  <label className={style.label} htmlFor={name}>
    {type === 'textArea'
      ? <textarea
          className={cx('form-control', style.textArea)}
          name={name}
          value={value == null ? undefined : value}
          onChange={onChange}
          placeholder={placeholder}
          {...props}
        />
      : <input
          className="form-control"
          name={name}
          type={type}
          value={value == null ? undefined : value}
          onChange={onChange}
          placeholder={placeholder}
          {...props}
        />}
    {errorMessage &&
      <div
        className={cx('alert', 'alert-danger', style.errorMessage)}
        role="alert"
      >
        <span className={cx('fa', 'fa-info-circle', style.alertIcon)}></span>
        <span>{errorMessage}</span>
      </div>}
  </label>;

const FormComponent = ({ label, ...props }) =>
  label
    ? <FormComponentWithLabel {...props} />
    : <FormComponentWithoutLabel {...props} />;

FormComponent.propTypes = {
  label: PropTypes.bool,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string
};

FormComponent.defaultProps = {
  type: 'text',
  placeholder: '',
  required: false,
  disabled: false,
  value: '',
  errorMessage: ''
};

export default withStyles(style)(FormComponent);



// WEBPACK FOOTER //
// ./src/components/FormComponent/FormComponent.js